import { ContinueButton, RequiredNote } from './common.jsx';

// Multi-select chips (e.g. "who do you live with"). Stored as an array of labels.
export default function MultiSelect({ item, answers, setAnswer, onAdvance }) {
  const selected = Array.isArray(answers[item.id]) ? answers[item.id] : [];
  const incomplete = item.required && selected.length === 0;

  const toggle = (name) => {
    const next = selected.includes(name)
      ? selected.filter((n) => n !== name)
      : [...selected, name];
    setAnswer(item.id, next);
  };

  return (
    <>
      <h1>{item.label}</h1>
      <p className="sub">Select all that apply.</p>
      <div className="chipwrap">
        {item.options.map((name) => (
          <button
            key={name}
            className={`chip${selected.includes(name) ? ' on' : ''}`}
            onClick={() => toggle(name)}
          >
            {selected.includes(name) ? '✓ ' : ''}<span>{name}</span>
          </button>
        ))}
      </div>
      {incomplete && <RequiredNote />}
      <div className="spacer" style={{ height: 20 }} />
      <ContinueButton onClick={onAdvance} disabled={incomplete} />
    </>
  );
}
